<template>
  <v-tooltip top :disabled="missingFieldsList.length === 0">
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <slot />
      </div>
    </template>

    <div style="text-align: left">
      <span>{{ $t("MissingFields") }}:</span>

      <div v-for="field in missingFieldsList" :key="field">
        <span style="text-transform: capitalize; font-size: 12px">
          {{ $t(field) }}
        </span>
      </div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "MissingFieldsTooltip",

  props: {
    /**
     * List of mandatory fields that remain to be filled
     */
    missingFieldsList: {
      type: Array,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Atoms/MissingFieldsTooltip.vue